var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72001 1.26001C3.70861 1.26001 1.26001 3.70861 1.26001 6.72001V14.28C1.26001 17.2914 3.70861 19.74 6.72001 19.74H14.28C17.2914 19.74 19.74 17.2914 19.74 14.28V6.72001C19.74 3.70861 17.2914 1.26001 14.28 1.26001H6.72001ZM15.54 4.62001C16.002 4.62001 16.38 4.99801 16.38 5.46001C16.38 5.92201 16.002 6.30001 15.54 6.30001C15.078 6.30001 14.7 5.92201 14.7 5.46001C14.7 4.99801 15.078 4.62001 15.54 4.62001ZM10.5 5.88001C13.0494 5.88001 15.12 7.95061 15.12 10.5C15.12 13.0494 13.0494 15.12 10.5 15.12C7.95061 15.12 5.88001 13.0494 5.88001 10.5C5.88001 7.95061 7.95061 5.88001 10.5 5.88001ZM10.5 6.72001C8.41681 6.72001 6.72001 8.41681 6.72001 10.5C6.72001 12.5832 8.41681 14.28 10.5 14.28C12.5832 14.28 14.28 12.5832 14.28 10.5C14.28 8.41681 12.5832 6.72001 10.5 6.72001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIco);
export default __webpack_public_path__ + "static/media/instagram-ico.b3533e8c10899274244b619c1c659025.svg";
export { ForwardRef as ReactComponent };